import React, { Component } from 'react';

import {RightColumn} from "../../Common/pages/RightColumn";
import {StandardPage} from "../../Common/pages/StandardPage";
import PropTypes from "prop-types";

export default class FootballVidiprinterPageLayout extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    FootballVidiprinterPageContainer: PropTypes.element.isRequired
  };

  render() {
    const {
      location,
      FootballVidiprinterPageContainer
    } = this.props;

    return (
      <StandardPage sport="racing" title="Live Vidiprinter" >
        <div className="main-layout-left-column">
          {FootballVidiprinterPageContainer}
        </div>

        <RightColumn location={location}
                     sport="football"
                     content={["topMpu"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballVidiprinterPageLayout.js